<template>
  <v-card class="elevation-12" width="400">
    <v-toolbar color="" flat>
      <img :src="require('@/assets/images/logo.jpg')" style="width: 125px" />
    </v-toolbar>

    <v-card-text>
      <v-form @submit.prevent="login">
        <v-text-field
          id="input-1"
          required
          v-model="email"
          type="email"
          label="Email"
          prepend-icon="mdi-email"
        ></v-text-field>
        <v-text-field
          required
          v-model="password"
          type="password"
          label="Password"
          prepend-icon="mdi-lock"
        ></v-text-field>

        <v-alert v-model="showLoginFailed" color="error" dark
          >Napaka pri prijavi!</v-alert
        >

        <v-card-actions>
          <v-btn type="submit" color="primary" block>Prijava</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      email: "",
      password: "",
      showLoginFailed: false,
    }),
    methods: {
      login() {
        this.$store
          .dispatch("user/login", {
            email: this.email,
            password: this.password,
          })
          .then(() => {
            this.$router.push({ name: "Companies" });
          })
          .catch(() => {
            this.showLoginFailed = true;
          });
      },
    },
  };
</script>
<style></style>
